import React from "react";
import { CTAButton } from "./CTAButton";
type TransformCTAProps = {
  headline: string;
  label: string;
  note?: string;
  dark?: boolean;
};
export function TransformCTA({
  headline,
  label,
  note = "$27 USD · One-time payment · Digital product",
  dark = false
}: TransformCTAProps) {
  return <div className="mx-auto mt-14 max-w-xl text-center" data-id="element-378" data-mp="2uua60p9n9af3">
      <p className={`font-display text-2xl font-bold uppercase leading-tight sm:text-3xl ${dark ? "text-white" : "text-ink"}`} data-id="element-379" data-mp="2uwwd6nsmhnws">
        {headline}
      </p>
      <CTAButton label={label} className="mt-5" data-id="element-380" data-mp="235gp0pbf3t4g" />
      <p className={`mt-3 text-sm font-medium ${dark ? "text-white/70" : "text-muted"}`} data-id="element-381" data-mp="2h3f27re05jid">{note}</p>
    </div>;
}